<template>
  <base-checkbox :value="value" @input="handleChange">
    <template #label>
      <span class="terms-of-use-label">
        <rich-text key-name="WithdrawToCard | termsOfUsePlainText">
          <template #link="{ text }">
            <a
              href="https://paybis.com/policies/terms-of-service/"
              target="_blank"
              class="terms-of-use-label-link"
            >
              {{ text }}
            </a>
          </template>
        </rich-text>
      </span>
    </template>
  </base-checkbox>
</template>

<script>
import RichText from '@emcd-shared/rich-text'
import { BaseCheckbox } from '@/shared/ui/BaseCheckbox'

export default {
  name: 'TermsOfUseCheckbox',

  components: {
    BaseCheckbox,
    RichText,
  },

  props: {
    value: {
      type: Boolean,
      default: false,
    },
  },

  emits: ['input'],

  methods: {
    handleChange(value) {
      this.$emit('input', value)
    },
  },
}
</script>

<style scoped lang="scss">
.terms-of-use-label {
  font-size: 14px;
  font-weight: 500;
}

.terms-of-use-label-link {
  color: var(--brand);
}
</style>
